// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 灵感画布项目管理页面样式 - 瀑布流高级版
 */

/* 滚动条样式优化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
  transition: background 0.2s;
}

::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* 容器基础样式 */
.InspirationCanvas-container {
  min-height: calc(100vh - 72px);
  background: #e8e5dc;
  overflow-x: hidden;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 - 极简风格 */
.InspirationCanvas-header {
  background: #e8e5dc;
  /* 去掉 sticky，让其随页面滚动，避免遮挡可能的全局导航 */
  position: relative;
  z-index: 10;
  border-bottom: 1px solid rgba(17, 18, 15, 0.16);
  transition: all 0.3s ease;
}

.InspirationCanvas-header-inner {
  max-width: 1800px; /* 更宽的视口 */
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  min-height: 184px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 36px;
  padding-top: 44px;
  padding-bottom: 28px;
}

.InspirationCanvas-heading {
  max-width: 820px;
}

.InspirationCanvas-brand-logo {
  display: block;
  width: 150px;
  max-width: 45vw;
  height: auto;
  margin: 0 auto 20px;
}

.InspirationCanvas-heading h1 {
  margin: 0;
  color: #11120f;
  font-family: Georgia, 'Songti SC', serif;
  font-size: clamp(34px, 4vw, 62px);
  font-weight: 400;
  letter-spacing: -0.045em;
  line-height: 1.03;
}

/* Tab 切换样式 - 左侧对齐 */
.InspirationCanvas-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
}

.InspirationCanvas-tab {
  min-width: 92px;
  padding: 10px 15px;
  color: #74796f;
  border: 1px solid #bdbbb1;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  user-select: none;
}

.InspirationCanvas-tab span {
  margin-left: 5px;
  font-family: Georgia, serif;
}

.InspirationCanvas-tab:hover {
  color: #1e293b;
}

.InspirationCanvas-tab.active {
  color: #11120f;
  background: #d8ff45;
  border-color: #11120f;
  font-size: 0.82rem;
}

.InspirationCanvas-tab.active::after {
  display: none;
}

/* 主内容区 */
.InspirationCanvas-main {
  padding: 2rem 2rem 4rem;
  max-width: 1800px;
  width: 100%;
  margin: 0 auto;
  flex: 1;
}

.InspirationCanvas-login-prompt {
  display: grid;
  min-height: 190px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 20px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #dfe4e0;
  border-radius: 16px;
  box-shadow: 0 10px 32px rgba(24, 30, 26, 0.06);
}

.InspirationCanvas-login-prompt-mark {
  display: grid;
  width: 54px;
  height: 54px;
  place-items: center;
  color: #fff;
  background: #171a17;
  border-radius: 15px;
  font-size: 22px;
  font-weight: 700;
}

.InspirationCanvas-login-prompt h3 { margin: 0 0 7px; color: #171a17; font-size: 18px; }
.InspirationCanvas-login-prompt p { margin: 0; color: #737b75; font-size: 13px; }
.InspirationCanvas-login-prompt button {
  min-height: 42px;
  padding: 9px 20px;
  color: #171a17;
  background: #e3f3cb;
  border: 1px solid #b9df8a;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.InspirationCanvas-login-prompt button:hover { background: #d7edb8; border-color: #8fbd5c; }

/* 瀑布流布局 - Flex 分列实现 */
.InspirationCanvas-masonry-container {
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
}

.InspirationCanvas-masonry-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0; /* 防止 flex item 溢出 */
}

/* 瀑布流卡片容器 */
.InspirationCanvas-masonry-item {
  position: relative;
  transform: translateZ(0); /* 硬件加速 */
  transition: z-index 0s; /* 只有 hover 时提高 z-index */
}

.InspirationCanvas-masonry-item:hover {
  z-index: 2; /* 悬停时层级提高 */
}

/* 卡片内容 */
.InspirationCanvas-card-content {
  background: #11120f;
  border-radius: 3px 22px 3px 3px;
  /* border-radius: 8px; */ /* 不规则排布通常不需要太大圆角，或者很小的圆角 */
  overflow: hidden; /* 溢出隐藏 */
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); */ /* 去掉阴影，更像图片墙 */
  position: relative;
  cursor: pointer;
  /* transition: box-shadow 0.3s ease; */
}

/* 图片容器 - 高度自适应 */
.InspirationCanvas-card-thumbnail {
  width: 100%;
  background: #f1f5f9;
  display: block;
  overflow: hidden;
}

.InspirationCanvas-card-thumbnail img {
  width: 100%;
  height: auto; /* 保持原始比例 */
  display: block; /* 消除底部空隙 */
  transition: transform 0.5s ease;
}

/* 鼠标放到盒子上，里面的图片放大 */
.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-thumbnail img {
  transform: scale(1.045);
}

/* 占位符 */
.InspirationCanvas-card-placeholder {
  width: 100%;
  padding-top: 100%; /* 默认正方形 */
  position: relative;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.InspirationCanvas-card-placeholder svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #94a3b8;
}

/* 信息浮层 - 常驻显示 */
.InspirationCanvas-card-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px 16px 12px;
  /* 更加明显的渐变，保证文字可见性 */
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 60%, transparent 100%);
  opacity: 1; /* 常驻显示 */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  pointer-events: none; /* 保证点击穿透 */
}

.InspirationCanvas-card-title {
  color: white;
  font-family: Georgia, 'Songti SC', serif;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0,0,0,0.5);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 820px) {
  .InspirationCanvas-header-inner {
    min-height: 210px;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    padding: 32px 1rem 24px;
  }

  .InspirationCanvas-main { padding: 1rem 1rem 3rem; }
}

/* 操作按钮 - 悬停显示 */
.InspirationCanvas-card-actions {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 6px;
  z-index: 10;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-actions {
  opacity: 1;
  transform: translateY(0);
}

.InspirationCanvas-action-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  border: none;
  color: #1e293b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.InspirationCanvas-action-btn:hover {
  background: white;
  transform: scale(1.1);
}

.InspirationCanvas-delete-btn:hover {
  color: #ef4444;
}

.InspirationCanvas-edit-btn:hover {
  color: #3b82f6;
}

/* 创建卡片 - 极简风格 */
.InspirationCanvas-create-card {
  background: white;
  /* border-radius: 8px; */
  border: 2px dashed #cbd5e1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 200px; /* 不需要太高 */
  box-shadow: none;
  height: 100%; /* 撑满 */
}

.InspirationCanvas-create-card:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.InspirationCanvas-create-content {
  text-align: center;
  padding: 1.5rem;
}

.InspirationCanvas-create-icon {
  color: #94a3b8;
  margin-bottom: 0.75rem;
  transition: transform 0.3s ease;
}

.InspirationCanvas-create-card:hover .InspirationCanvas-create-icon {
  transform: scale(1.1) rotate(90deg);
  color: #64748b;
}

.InspirationCanvas-create-text {
  font-size: 1rem;
  font-weight: 700;
  color: #64748b;
  margin: 0;
}

/* 状态提示 */
.InspirationCanvas-loading,
.InspirationCanvas-no-more,
.InspirationCanvas-empty-message {
  text-align: center;
  padding: 3rem;
  color: #94a3b8;
  font-size: 0.95rem;
  font-weight: 500;
  width: 100%;
}

.InspirationCanvas-error {
  text-align: center;
  padding: 2rem;
  background: #fef2f2;
  border-radius: 12px;
  border: 1px solid #fecaca;
  margin-bottom: 2rem;
  color: #b91c1c;
}

/* 对话框样式 */
.InspirationCanvas-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6); /* 加深背景 */
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.InspirationCanvas-dialog {
  background: white;
  border-radius: 24px;
  padding: 2.5rem;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: dialogPop 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes dialogPop {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.InspirationCanvas-dialog-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 1.5rem 0;
  text-align: center;
}

.InspirationCanvas-form-input,
.InspirationCanvas-form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.2s;
  background: #f8fafc;
  color: #1e293b;
}

.InspirationCanvas-form-input:focus,
.InspirationCanvas-form-textarea:focus {
  background: white;
  border-color: #0f172a;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
  outline: none;
}

.InspirationCanvas-dialog-actions {
  display: flex;
  gap: 12px;
  margin-top: 2rem;
}

.InspirationCanvas-dialog-button {
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.InspirationCanvas-dialog-button-cancel {
  background: #f1f5f9;
  color: #64748b;
}

.InspirationCanvas-dialog-button-cancel:hover {
  background: #e2e8f0;
  color: #334155;
}

.InspirationCanvas-dialog-button-save {
  background: #0f172a;
  color: white;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
}

.InspirationCanvas-dialog-button-save:hover {
  background: #1e293b;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.25);
}

.InspirationCanvas-dialog-button-delete {
  background: #ef4444;
  color: white;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.InspirationCanvas-dialog-button-delete:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

/* 升级弹窗相关复用 */
.InspirationCanvas-upgrade-dialog {
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.InspirationCanvas-upgrade-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fef3c7;
  color: #d97706;
}

.InspirationCanvas-upgrade-message {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  color: #0369a1;
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.InspirationCanvas-upgrade-benefits {
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
  text-align: left;
}

.InspirationCanvas-upgrade-benefits li {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #475569;
}

.InspirationCanvas-upgrade-benefits li::before {
  content: '✓';
  color: #10b981;
  font-weight: 800;
}

.InspirationCanvas-upgrade-button {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .InspirationCanvas-header-inner {
    padding: 0 1rem;
    height: 56px;
  }

  .InspirationCanvas-tabs {
    gap: 20px;
  }

  .InspirationCanvas-tab {
    font-size: 0.9rem;
  }

  .InspirationCanvas-main {
    padding: 1rem 1rem 3rem;
  }
  
  .InspirationCanvas-masonry-container {
    gap: 2px;
  }
  
  .InspirationCanvas-masonry-column {
    gap: 2px;
  }
  
  .InspirationCanvas-create-card {
    min-height: 160px;
  }

  .InspirationCanvas-login-prompt {
    grid-template-columns: auto 1fr;
    gap: 14px;
    padding: 22px;
  }

  .InspirationCanvas-login-prompt button { grid-column: 1 / -1; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/inspirationCanvas/InspirationCanvas.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,YAAY;AACZ;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB,EAAE,UAAU;EAC7B,WAAW;EACX,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,wCAAwC;EACxC,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,OAAO;AACT;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACvF,oCAAoC,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAChF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+CAA+C,mBAAmB,EAAE,qBAAqB,EAAE;;AAE3F,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY,EAAE,oBAAoB;AACpC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,wBAAwB,EAAE,SAAS;EACnC,sBAAsB,EAAE,yBAAyB;AACnD;;AAEA;EACE,UAAU,EAAE,YAAY;AAC1B;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB,EAAE,2BAA2B;EACrD,gBAAgB,EAAE,SAAS;EAC3B,gDAAgD,EAAE,eAAe;EACjE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,WAAW;EACzB,cAAc,EAAE,WAAW;EAC3B,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;AACzB;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,iBAAiB,EAAE,UAAU;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,oBAAoB;EACpB,8FAA8F;EAC9F,UAAU,EAAE,SAAS;EACrB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB,EAAE,WAAW;AACnC;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA,0BAA0B,uBAAuB,EAAE;AACrD;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,QAAQ;EACR,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB,EAAE,UAAU;EAC7B,gBAAgB;EAChB,YAAY,EAAE,OAAO;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,SAAS;AACT;;;EAGE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B,EAAE,SAAS;EACzC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,uDAAuD;AACzD;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,SAAS;IACT,aAAa;EACf;;EAEA,yCAAyC,mBAAmB,EAAE;AAChE","sourcesContent":["/**\n * 灵感画布项目管理页面样式 - 瀑布流高级版\n */\n\n/* 滚动条样式优化 */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n  transition: background 0.2s;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n/* 容器基础样式 */\n.InspirationCanvas-container {\n  min-height: calc(100vh - 72px);\n  background: #e8e5dc;\n  overflow-x: hidden;\n  max-width: 100vw;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 顶部导航栏 - 极简风格 */\n.InspirationCanvas-header {\n  background: #e8e5dc;\n  /* 去掉 sticky，让其随页面滚动，避免遮挡可能的全局导航 */\n  position: relative;\n  z-index: 10;\n  border-bottom: 1px solid rgba(17, 18, 15, 0.16);\n  transition: all 0.3s ease;\n}\n\n.InspirationCanvas-header-inner {\n  max-width: 1800px; /* 更宽的视口 */\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n  min-height: 184px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 36px;\n  padding-top: 44px;\n  padding-bottom: 28px;\n}\n\n.InspirationCanvas-heading {\n  max-width: 820px;\n}\n\n.InspirationCanvas-brand-logo {\n  display: block;\n  width: 150px;\n  max-width: 45vw;\n  height: auto;\n  margin: 0 auto 20px;\n}\n\n.InspirationCanvas-heading h1 {\n  margin: 0;\n  color: #11120f;\n  font-family: Georgia, 'Songti SC', serif;\n  font-size: clamp(34px, 4vw, 62px);\n  font-weight: 400;\n  letter-spacing: -0.045em;\n  line-height: 1.03;\n}\n\n/* Tab 切换样式 - 左侧对齐 */\n.InspirationCanvas-tabs {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.InspirationCanvas-tab {\n  min-width: 92px;\n  padding: 10px 15px;\n  color: #74796f;\n  border: 1px solid #bdbbb1;\n  border-radius: 999px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  user-select: none;\n}\n\n.InspirationCanvas-tab span {\n  margin-left: 5px;\n  font-family: Georgia, serif;\n}\n\n.InspirationCanvas-tab:hover {\n  color: #1e293b;\n}\n\n.InspirationCanvas-tab.active {\n  color: #11120f;\n  background: #d8ff45;\n  border-color: #11120f;\n  font-size: 0.82rem;\n}\n\n.InspirationCanvas-tab.active::after {\n  display: none;\n}\n\n/* 主内容区 */\n.InspirationCanvas-main {\n  padding: 2rem 2rem 4rem;\n  max-width: 1800px;\n  width: 100%;\n  margin: 0 auto;\n  flex: 1;\n}\n\n.InspirationCanvas-login-prompt {\n  display: grid;\n  min-height: 190px;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 20px;\n  padding: 30px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid #dfe4e0;\n  border-radius: 16px;\n  box-shadow: 0 10px 32px rgba(24, 30, 26, 0.06);\n}\n\n.InspirationCanvas-login-prompt-mark {\n  display: grid;\n  width: 54px;\n  height: 54px;\n  place-items: center;\n  color: #fff;\n  background: #171a17;\n  border-radius: 15px;\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.InspirationCanvas-login-prompt h3 { margin: 0 0 7px; color: #171a17; font-size: 18px; }\n.InspirationCanvas-login-prompt p { margin: 0; color: #737b75; font-size: 13px; }\n.InspirationCanvas-login-prompt button {\n  min-height: 42px;\n  padding: 9px 20px;\n  color: #171a17;\n  background: #e3f3cb;\n  border: 1px solid #b9df8a;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.InspirationCanvas-login-prompt button:hover { background: #d7edb8; border-color: #8fbd5c; }\n\n/* 瀑布流布局 - Flex 分列实现 */\n.InspirationCanvas-masonry-container {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  align-items: flex-start;\n}\n\n.InspirationCanvas-masonry-column {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0; /* 防止 flex item 溢出 */\n}\n\n/* 瀑布流卡片容器 */\n.InspirationCanvas-masonry-item {\n  position: relative;\n  transform: translateZ(0); /* 硬件加速 */\n  transition: z-index 0s; /* 只有 hover 时提高 z-index */\n}\n\n.InspirationCanvas-masonry-item:hover {\n  z-index: 2; /* 悬停时层级提高 */\n}\n\n/* 卡片内容 */\n.InspirationCanvas-card-content {\n  background: #11120f;\n  border-radius: 3px 22px 3px 3px;\n  /* border-radius: 8px; */ /* 不规则排布通常不需要太大圆角，或者很小的圆角 */\n  overflow: hidden; /* 溢出隐藏 */\n  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); */ /* 去掉阴影，更像图片墙 */\n  position: relative;\n  cursor: pointer;\n  /* transition: box-shadow 0.3s ease; */\n}\n\n/* 图片容器 - 高度自适应 */\n.InspirationCanvas-card-thumbnail {\n  width: 100%;\n  background: #f1f5f9;\n  display: block;\n  overflow: hidden;\n}\n\n.InspirationCanvas-card-thumbnail img {\n  width: 100%;\n  height: auto; /* 保持原始比例 */\n  display: block; /* 消除底部空隙 */\n  transition: transform 0.5s ease;\n}\n\n/* 鼠标放到盒子上，里面的图片放大 */\n.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-thumbnail img {\n  transform: scale(1.045);\n}\n\n/* 占位符 */\n.InspirationCanvas-card-placeholder {\n  width: 100%;\n  padding-top: 100%; /* 默认正方形 */\n  position: relative;\n  background: #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.InspirationCanvas-card-placeholder svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #94a3b8;\n}\n\n/* 信息浮层 - 常驻显示 */\n.InspirationCanvas-card-info {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 40px 16px 12px;\n  /* 更加明显的渐变，保证文字可见性 */\n  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 60%, transparent 100%);\n  opacity: 1; /* 常驻显示 */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  pointer-events: none; /* 保证点击穿透 */\n}\n\n.InspirationCanvas-card-title {\n  color: white;\n  font-family: Georgia, 'Songti SC', serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  margin: 0;\n  text-shadow: 0 1px 3px rgba(0,0,0,0.5);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n@media (max-width: 820px) {\n  .InspirationCanvas-header-inner {\n    min-height: 210px;\n    align-items: flex-start;\n    flex-direction: column;\n    justify-content: center;\n    padding: 32px 1rem 24px;\n  }\n\n  .InspirationCanvas-main { padding: 1rem 1rem 3rem; }\n}\n\n/* 操作按钮 - 悬停显示 */\n.InspirationCanvas-card-actions {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  gap: 6px;\n  z-index: 10;\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-actions {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.InspirationCanvas-action-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(4px);\n  border: none;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.InspirationCanvas-action-btn:hover {\n  background: white;\n  transform: scale(1.1);\n}\n\n.InspirationCanvas-delete-btn:hover {\n  color: #ef4444;\n}\n\n.InspirationCanvas-edit-btn:hover {\n  color: #3b82f6;\n}\n\n/* 创建卡片 - 极简风格 */\n.InspirationCanvas-create-card {\n  background: white;\n  /* border-radius: 8px; */\n  border: 2px dashed #cbd5e1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-height: 200px; /* 不需要太高 */\n  box-shadow: none;\n  height: 100%; /* 撑满 */\n}\n\n.InspirationCanvas-create-card:hover {\n  border-color: #94a3b8;\n  background: #f8fafc;\n}\n\n.InspirationCanvas-create-content {\n  text-align: center;\n  padding: 1.5rem;\n}\n\n.InspirationCanvas-create-icon {\n  color: #94a3b8;\n  margin-bottom: 0.75rem;\n  transition: transform 0.3s ease;\n}\n\n.InspirationCanvas-create-card:hover .InspirationCanvas-create-icon {\n  transform: scale(1.1) rotate(90deg);\n  color: #64748b;\n}\n\n.InspirationCanvas-create-text {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #64748b;\n  margin: 0;\n}\n\n/* 状态提示 */\n.InspirationCanvas-loading,\n.InspirationCanvas-no-more,\n.InspirationCanvas-empty-message {\n  text-align: center;\n  padding: 3rem;\n  color: #94a3b8;\n  font-size: 0.95rem;\n  font-weight: 500;\n  width: 100%;\n}\n\n.InspirationCanvas-error {\n  text-align: center;\n  padding: 2rem;\n  background: #fef2f2;\n  border-radius: 12px;\n  border: 1px solid #fecaca;\n  margin-bottom: 2rem;\n  color: #b91c1c;\n}\n\n/* 对话框样式 */\n.InspirationCanvas-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6); /* 加深背景 */\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.InspirationCanvas-dialog {\n  background: white;\n  border-radius: 24px;\n  padding: 2.5rem;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: dialogPop 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes dialogPop {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.InspirationCanvas-dialog-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 1.5rem 0;\n  text-align: center;\n}\n\n.InspirationCanvas-form-input,\n.InspirationCanvas-form-textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  transition: all 0.2s;\n  background: #f8fafc;\n  color: #1e293b;\n}\n\n.InspirationCanvas-form-input:focus,\n.InspirationCanvas-form-textarea:focus {\n  background: white;\n  border-color: #0f172a;\n  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);\n  outline: none;\n}\n\n.InspirationCanvas-dialog-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 2rem;\n}\n\n.InspirationCanvas-dialog-button {\n  flex: 1;\n  padding: 12px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.InspirationCanvas-dialog-button-cancel {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.InspirationCanvas-dialog-button-cancel:hover {\n  background: #e2e8f0;\n  color: #334155;\n}\n\n.InspirationCanvas-dialog-button-save {\n  background: #0f172a;\n  color: white;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);\n}\n\n.InspirationCanvas-dialog-button-save:hover {\n  background: #1e293b;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.25);\n}\n\n.InspirationCanvas-dialog-button-delete {\n  background: #ef4444;\n  color: white;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);\n}\n\n.InspirationCanvas-dialog-button-delete:hover {\n  background: #dc2626;\n  transform: translateY(-1px);\n}\n\n/* 升级弹窗相关复用 */\n.InspirationCanvas-upgrade-dialog {\n  text-align: center;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.InspirationCanvas-upgrade-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  margin: 0 auto 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.InspirationCanvas-upgrade-message {\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  color: #0369a1;\n  padding: 1rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.InspirationCanvas-upgrade-benefits {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 2rem 0;\n  text-align: left;\n}\n\n.InspirationCanvas-upgrade-benefits li {\n  padding: 0.5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #475569;\n}\n\n.InspirationCanvas-upgrade-benefits li::before {\n  content: '✓';\n  color: #10b981;\n  font-weight: 800;\n}\n\n.InspirationCanvas-upgrade-button {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: white;\n}\n\n/* 移动端适配 */\n@media (max-width: 768px) {\n  .InspirationCanvas-header-inner {\n    padding: 0 1rem;\n    height: 56px;\n  }\n\n  .InspirationCanvas-tabs {\n    gap: 20px;\n  }\n\n  .InspirationCanvas-tab {\n    font-size: 0.9rem;\n  }\n\n  .InspirationCanvas-main {\n    padding: 1rem 1rem 3rem;\n  }\n  \n  .InspirationCanvas-masonry-container {\n    gap: 2px;\n  }\n  \n  .InspirationCanvas-masonry-column {\n    gap: 2px;\n  }\n  \n  .InspirationCanvas-create-card {\n    min-height: 160px;\n  }\n\n  .InspirationCanvas-login-prompt {\n    grid-template-columns: auto 1fr;\n    gap: 14px;\n    padding: 22px;\n  }\n\n  .InspirationCanvas-login-prompt button { grid-column: 1 / -1; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
